import { Box } from '@mui/material';
import { useApi } from 'contexts/Api/Api';
import { useRouter } from 'next/router';
import { useMemo } from 'react';
import DocHead from '../DocHead/DocHead';
import Footer from '../Footer/Footer';
import Header from '../Header/Header';
import HeaderControls from '../HeaderControls/HeaderControls';
import LandingAuthControls from '../LandingAuthControls/LandingAuthControls';
import MobileWarning from '../MobileWarning/MobileWarning';
import Progress from '../Progress/Progress';
import SettingsControls from '../SettingsControls/SettingsControls';
import UserAvatarMenu from '../UserAvatarMenu/UserAvatarMenu';

export default function Main({ children }: MainProps) {
    const api = useApi();
    const router = useRouter();

    const routePath = useMemo(() => {
        return router.asPath.split(/[?#]/)[0];
    }, [router.asPath]);

    const showGuestLessonShell = useMemo(() => {
        return routePath.startsWith('/lessons/') && api.authConfigured && !api.user;
    }, [api.authConfigured, api.user, routePath]);

    const wrap = useMemo(() => {
        return routePath.startsWith('/lessons/') && !showGuestLessonShell;
    }, [routePath, showGuestLessonShell]);

    const landing = useMemo(() => {
        return routePath === '/' || showGuestLessonShell;
    }, [routePath, showGuestLessonShell]);

    return (
        <Box display="flex" flexDirection="column" minHeight="100vh">
            <DocHead />
            <MobileWarning minWidth={800}>
                <Box
                    component="main"
                    display="flex"
                    flexDirection="column"
                    flex={1}
                    order={2}
                    padding={wrap ? 3 : undefined}
                    position="relative"
                >
                    {wrap ? (
                        <Box marginX="auto" width="100%" maxWidth={1328} paddingY={2} position="relative">
                            {children}
                        </Box>
                    ) : (
                        children
                    )}
                    {process.env.NEXT_PUBLIC_ADMIN && <SettingsControls />}
                </Box>
            </MobileWarning>
            <Header>
                {landing ? (
                    <LandingAuthControls />
                ) : (
                    <>
                        <Progress />
                        <HeaderControls />
                        {api.user && <UserAvatarMenu />}
                    </>
                )}
            </Header>
            <Footer />
        </Box>
    );
}
